import React from "react";
import "./App.css";

import { AuthenticatedUserProvider } from "./providers/AuthenticatedUserProvider";

import { Main } from "./Main";

import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@rest-hooks/react";
import { LoadingProvider } from "./hooks/useGlobalLoading";

// Configure Amplify (can be mocked ONLY in local development)
const useMockAuth =
  process.env.REACT_APP_USE_MOCK_AUTH === "true" &&
  process.env.NODE_ENV === "development";

if (!useMockAuth) {
  Amplify.configure(awsExports);
}

const theme = createTheme({
  typography: {
    fontFamily: '"DM Sans", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LoadingProvider>
        <AuthenticatedUserProvider>
          <CacheProvider>
            <Main />
          </CacheProvider>
        </AuthenticatedUserProvider>
      </LoadingProvider>
    </ThemeProvider>
  );
}

export default App;
